import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthentication } from "./AuthenticationProvider";
import { isAccountantOnlyUser, isOrOnlyUser } from "./roleHelpers";

// Landing-route guard for the `/admin/` index route, which renders the staff
// Sales View. Decides BEFORE the page mounts where a narrow-role session
// lands instead; everyone else gets the page, untouched. Deliberately scoped
// to the index route only.
//
// Accountant-only sessions (external CPA principal, PR #2336): the Sales
// View's page-level queries are admin-gated; for a pure ACCOUNTANT they are
// rejected before the sidebar (and MainMenu's own redirect-to-Accounting
// effect) ever mounts, so the CPA's very first page after sign-in was React
// Router's "Unexpected Application Error". Accountant-only → straight to
// /admin/accounting. Every other admin route the CPA might type is handled by
// MainMenu's redirect once the shell renders, and the five accountant-menu
// pages need no redirect.
//
// OR-only sessions (2026-10-05, OR Board owner decision D5) land on the
// surgery calendar, the first entry of their menu, instead of the Sales View.
// An OR user can still open /admin/patients from the menu.
export const AdminHomeRedirect = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { user } = useAuthentication();
  if (isAccountantOnlyUser(user)) {
    return <Navigate to="/admin/accounting" replace />;
  }
  if (isOrOnlyUser(user)) {
    return <Navigate to="/admin/calendar_dashboard" replace />;
  }
  return <>{children}</>;
};
